// extracted by mini-css-extract-plugin
module.exports = {"iconSync":"map_iconSync__3MVKj","fa-spin":"map_fa-spin__3ccpe"};